module.exports = __webpack_public_path__ + "img/caret-right.ca442eb1.svg";